import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import AppAlert from './AppAlert.vue'
import Teleport from 'vue2-teleport'
import { TransitionFade } from '@morev/vue-transitions'

type AlertProps = InstanceType<typeof AppAlert>['$props']
type AlertLevel = AlertProps['level']
type AlertData = Omit<AlertProps, 'level'>


const duration = 10 * 1000

export default /*#__PURE__*/_defineComponent({
  __name: 'AppAlertDisplayer',
  setup(__props, { expose }) {

const alertProps = ref<AlertProps>()

const visible = ref(false)
 // 10s
const currentTimeout = ref<number>()

function show(level: AlertLevel, data: AlertData) {
  if (currentTimeout.value) {
    window.clearTimeout(currentTimeout.value)
  }

  alertProps.value = {
    ...data,
    level,
  }
  visible.value = true

  currentTimeout.value = window.setTimeout(() => {
    close()
  }, duration)
}
function close() {
  visible.value = false
  alertProps.value = undefined
  currentTimeout.value = undefined
}

expose({
  show,
})

return { __sfc: true,duration, alertProps, visible, currentTimeout, show, close, AppAlert, Teleport, TransitionFade }
}

})